<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_poke`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <pokeFilter ref="pokeFilter" @filterPokeItem="filterPokeItems"></pokeFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-2">
                            <pokeList ref="pokeList" @setMemberFilter="setMemberFilter" @setExportData="setExportData"></pokeList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import PokeFilter from './Poke_Filter'
import PokeList from './Poke_List'

export default {
    name: "reportPoke",
    components:{
        PokeFilter, PokeList, BreadCrumb
    },
    data(){
        return {
            filterObj: {}, 
        }
    },
    methods:{
        filterPokeItems(filterObj){
            this.filterObj = filterObj;
            this.$refs.pokeList.setPokeItems(this.filterObj);
        },
        setMemberFilter(data, member){
            this.$refs.pokeFilter.setMemberFilter(data, member)
        },
        setExportData(data){
            this.$refs.pokeFilter.setExportData(data)
        },
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>